/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { Script } from "gatsby"
import * as React from "react"

export const scripts = {
  mattearley: [
    <Script src="https://www.googletagmanager.com/gtag/js?id=AW-17875953726" />,
    <Script
      onLoad={() => {
        window.dataLayer = window.dataLayer || []
        function gtag() {
          window.dataLayer.push(arguments)
        }
        gtag("js", new Date())
        gtag("config", "AW-17875953726")
      }}
    />,
  ],
}
